export const ACTIVE_APPLICATION_ID_HEADER = 'ACTIVE-APPLICATION-ID';

export function getActiveApplicationId(): number {
  return +localStorage.getItem('active_application_id') || null;
}

export function setActiveApplicationId(value: number): void {
  localStorage.setItem('active_application_id', value ? value.toString() : null);
}

